<template>
  <div class="row">
    <div class="col-md-12 fme-small-cards">
      <div class="row fme-small-cards-row">
        <div class="col-md-12" v-for="(item, index) in items[0].lineOne" :key="index">
          <BaseSmallCard :cardTitle="$t(`${item.title}.name`)" :cardUrl="item.router" cardType="small" :cardMoreLink="$t(`${item.title}.button`)" class="fme-card-small">
            <h1 slot="number"> {{ item.number }} </h1>
          </BaseSmallCard>
        </div>
      <!-- </div>

      <div class="row fme-small-cards-row"> -->
        <div class="col-md-12" v-for="(item, index) in items[1].lineTwo" :key="index">
          <BaseSmallCard :cardTitle="$t(`${item.title}.name`)" :cardUrl="item.router" cardType="small" :cardMoreLink="$t(`${item.title}.button`)" class="fme-card-small">
            <h1 slot="number"> {{ item.number }} </h1>
          </BaseSmallCard>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const BaseSmallCard = () => import('@/components/fragment/card/BaseSmallCard')

export default {
  name: 'CrudSmallCardNavigation',
  data () {
    return {
    }
  },
  props: {
    items: Array
  },
  components: {
    BaseSmallCard
  },
  computed: {
  }
}
</script>

<style lang="scss">
.fme-small-cards {
  padding-top: 15px;
  padding-bottom: 15px;
  .fme-small-cards-row:not(:first-child) {
    margin-top: 30px;
    & + div {
      padding-right: 8px;
    }
  }
}
</style>
